import { api } from './utils'

export interface IDonate {
	product: string
	productCode: string

	price: number

	description: string
	smallDescription: string

	image: string
	descriptionImage: string

	isDescriptionEnabled: boolean
}

export interface IDonatesListAnswer {
	success: boolean
	message: string
	donates: IDonate[]
}

export interface IBuyDonateAnswer {
	success: boolean
	message: string
	link: string
}

export async function getDonates(): Promise<IDonatesListAnswer> {
	const req = await fetch(`${api}/cabinet/getDonates`)

	return await req.json() as Promise<IDonatesListAnswer>
}

export async function buyDonate(productCode: string): Promise<IBuyDonateAnswer> {
	const req = await fetch(`${api}/cabinet/donate`, {
		method: 'POST',
		body: JSON.stringify({
			product: productCode
		})
	})

	return await req.json() as Promise<IBuyDonateAnswer>
}
